export default "__VITE_ASSET__61d542ed__"